import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Card, Table, Button, Alert, Spinner, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus, faSync } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ConfirmModal from '../ConfirmModal'; // Assumendo esista un ConfirmModal
import { getEmailTemplates, deleteEmailTemplate } from '../../services/api'; // Dovremo creare queste API functions

const EmailTemplateList = () => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [templateToDelete, setTemplateToDelete] = useState(null);
    const navigate = useNavigate();

    const fetchTemplates = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await getEmailTemplates(); // Implementare in services/api.js
            if (response && response.data) {
                setTemplates(response.data);
            } else {
                setTemplates([]);
            }
        } catch (err) {
            console.error("Errore nel recupero dei template email:", err);
            setError("Impossibile caricare i template email.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTemplates();
    }, [fetchTemplates]);

    const handleDeleteClick = (template) => {
        setTemplateToDelete(template);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        if (templateToDelete) {
            try {
                await deleteEmailTemplate(templateToDelete.id); // Implementare in services/api.js
                toast.success("Template eliminato con successo!");
                fetchTemplates(); // Ricarica la lista
            } catch (err) {
                console.error("Errore durante l'eliminazione del template:", err);
                toast.error("Errore durante l'eliminazione del template.");
            } finally {
                setShowDeleteModal(false);
                setTemplateToDelete(null);
            }
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
                <Spinner animation="border" />
            </div>
        );
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    return (
        <Container fluid>
            <Row className="mb-3">
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Gestione Template Email</h1>
                    <p className="mb-4">Qui puoi visualizzare e gestire i template delle email usati dal sistema.</p>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col className="d-flex justify-content-end">
                    <Button variant="primary" onClick={() => navigate('/email-templates/new')} className="me-2">
                        <FontAwesomeIcon icon={faPlus} className="me-1" /> Nuovo Template
                    </Button>
                    <Button variant="info" onClick={fetchTemplates}>
                        <FontAwesomeIcon icon={faSync} className="me-1" /> Aggiorna
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card shadow="sm">
                        <Card.Body>
                            {templates.length === 0 ? (
                                <Alert variant="info">Nessun template email trovato. Crea un nuovo template!</Alert>
                            ) : (
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nome</th>
                                            <th>Tipo</th>
                                            <th>Oggetto</th>
                                            <th>Azioni</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {templates.map(template => (
                                            <tr key={template.id}>
                                                <td>{template.id}</td>
                                                <td>{template.name}</td>
                                                <td>{template.type}</td>
                                                <td>{template.subject}</td>
                                                <td>
                                                    <Button variant="warning" size="sm" className="me-2" onClick={() => navigate(`/email-templates/edit/${template.id}`)}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </Button>
                                                    <Button variant="danger" size="sm" onClick={() => handleDeleteClick(template)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <ConfirmModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleConfirmDelete}
                title="Conferma Eliminazione"
                body={`Sei sicuro di voler eliminare il template "${templateToDelete?.name}" (ID: ${templateToDelete?.id})?`}
            />
        </Container>
    );
};

export default EmailTemplateList;
